type WindDirectionProps = {
	rotation: number;
	color: string;
};

export const WindDirection = ({ rotation, color }: WindDirectionProps) => {
	const cssRotation = (rotation + 180) % 360;

	return (
		<div
			className="wind-direction"
			style={{
				transform: `rotate(${cssRotation}deg)`,
				width: "100%",
				display: "inline-block",
			}}
		>
			<svg
				viewBox="0 0 22 22"
				width={"100%"}
				height={"100%"}
				fill={color}
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M0.420859 0.419847C0.225542 0.615463 0.0904564 0.863008 0.0322006 1.13209C-0.0260551 1.40117 -0.00494546 1.68008 0.0929239 1.93457L7.46137 21.117C7.5646 21.386 7.74866 21.615 7.98844 21.7729C8.22822 21.9307 8.51203 22.0097 8.80117 21.999C9.09031 21.9884 9.37069 21.8886 9.60407 21.7133C9.83744 21.538 10.0125 21.2958 10.1052 21.0196C10.1052 21.0196 10.5824 19.6011 11.3155 17.9324C12.0486 16.2638 13.1203 14.3381 13.8538 13.6216C14.5418 12.9495 16.4051 11.9661 18.0151 11.3038C19.625 10.6415 20.9893 10.2184 20.9893 10.2184C21.2693 10.1313 21.5168 9.95958 21.6976 9.72693C21.8784 9.49427 21.9834 9.21226 21.9982 8.91997C22.013 8.62769 21.9367 8.33964 21.78 8.09577C21.6233 7.8519 21.3939 7.6643 21.1236 7.55898L1.93175 0.0939412C1.67816 -0.00453509 1.40013 -0.0261472 1.13174 0.0317445C0.863354 0.0896363 0.616294 0.224517 0.420859 0.419847ZM3.87221 3.88874L16.6465 8.85752C14.9906 9.54945 13.1697 10.3912 11.9102 11.6215C10.5482 12.952 9.584 14.9531 8.80261 16.724L3.87221 3.88874Z"
					fill={color}
				/>
				<path
					d="M20.5963 8.87304C20.5963 8.87304 14.9141 10.6358 12.8814 12.6214C10.7579 14.6958 8.77427 20.5904 8.77427 20.5904L1.40428 1.408L20.5963 8.87304Z"
					fill={color}
				/>
			</svg>
		</div>
	);
};

export default WindDirection;
